<template>
	<div class="position-relative">
		<transition name="vue-table-loader">
		    <div class="vue-table-loader"v-if="loading"><span class="fa fa-cog fa-spin fa-3x"></span></div>
		</transition>
		<div class="row">
			<div class="col-md-4">
				<base-filter-bar placeholder="Search Categories"></base-filter-bar>
			</div>
			<div class="col-md-8">
				<base-select-visible :per-page="perPage" :amounts-shown="amountsShown"></base-select-visible>
			</div>
		</div>
		<div class="dataTables_wrapper container-fluid dt-bootstrap4 modern">
		    <vuetable ref="vuetable"
				:api-url="grid"
				:fields="fields"
				:css="css.table"
				:per-page="perPage"
				:append-params="moreParams"
				noDataTemplate="No Categories Found"
				pagination-path=""
				@vuetable:pagination-data="onPaginationData"
				@vuetable:loaded="onLoaded"

		    >
	    	    <template slot="productCount" slot-scope="props">
	    	    	<div class="text-center">
	    	    		<a class="btn btn-outline-primary" v-if="props.rowData.product_count >= 1" :href="'/products?category=' + props.rowData.id">View Products ({{props.rowData.product_count}})</a>
	    	    	</div>
		    	</template>
		    	<template slot="channels" slot-scope="props">
		    			<div class="channel-container" v-if="props.rowData.category_channels_count > 0">
		    				<a href="#" v-if="props.rowData.category_channels_count > 3" class="channel-expander" v-bind:class="{ scrolled: props.rowData.category_channels_count > 10 }" v-on:click.stop="expandChannelsList"></a>
		    				<div class="channel-item-container"  v-bind:class="{ scrolled: props.rowData.category_channels_count > 10 }">
		    					<div class="channel-item"  v-for="channel in props.rowData.category_channels">{{channel.channel_name}} </div>
		    				</div>
		    			</div>
		    	</template>
		    	<template slot="actions" slot-scope="props">
		    	        <a class="btn btn-outline-primary" :href="'/categories/' + props.rowData.id + '/edit/'">View</a>
		    	</template>
		    </vuetable>
		    <div class="row">
		    	<div class="col-md-6">
		    		<base-pagination-info
		    			:css="css.table"
		    			ref="paginationInfo"
		    		>
		    		</base-pagination-info>
		    	</div>
		    	<div class="col-md-6">
		    		<base-pagination  ref="pagination"
		    		  @vuetable-pagination:change-page="onChangePage"
		    		></base-pagination>
		    	</div>
		    </div>
		</div>
	</div>
</template>

<style lang="scss">
	.w220{
		width: 220px;
	}
	.w200{
		width: 200px;
	}
</style>
<style scoped lang="scss">
	.channel-container{
		position: relative;
		.channel-expander{
			background: #25628F;
			z-index:2;
			width: 16px;
			height: 16px;
			border-radius: 50%;
			color:#fff;
			position: absolute;
			text-align: center;
			right: 5px;
			bottom: 3px;
			font-size: 10px;
			padding-top: 1px;
			&:before{
				content: "\F110";
				font: normal normal normal 14px/1 "LineAwesome";
				color: #fff;
     			font-size: 10px;
			}
			&.open{
				&.scrolled{
					right: 7px;
				}
				&:before{
					content:"\f113";
				}
			}
		}
	}
	.channel-item-container{
		transition: all 0.3s;
		z-index:1;
		max-height: 59px;
		min-height: 59px;
		overflow:hidden;
		&.open{
			transition: all 0.5s;
			max-height: 199px;
		}
		&.scrolled{
			overflow-y:overlay;
		}
		&::-webkit-scrollbar {
		    width: 4px;
		}
		&::-webkit-scrollbar-track {
		    background: rgba(0,0,0,0.1);
		    position: absolute;
		    top: 0px;
		    bottom: 0px;
		    right: 0px;
		}
		&::-webkit-scrollbar-thumb {
		    background: #25628F;
		    border-radius:2px;
		}
		&::-webkit-scrollbar-thumb:hover {
		    background: #25628F;
		}
	}
	.channel-item{
		border-bottom:1px solid #dee0e1;
		padding: 2px 7px;
		font-size: 10px;
		position: relative;
		&:nth-child(n+3):last-child{
			border-color:transparent;
		}
	}
	.no-channel{
		text-align: center;
		padding: 20px 0;
	}
</style>

<script type="text/javascript">
	var base_url = window.location.protocol + "//" + window.location.host

	import Vue from 'vue';
	import VueEvents from 'vue-events'
	import * as Vuetable from 'vuetable-2';
	import moment from 'moment';
	import BaseFilterBar from './base-filter-bar.vue';
	import BasePagination from './base-pagination.vue';
	import BasePaginationInfo from './base-pagination-info.vue';
	import BaseSelectVisible from './base-select-visible.vue';

	Vue.use(VueEvents)

	export default {
	    name: 'category-grid-listing',
	    props: [],
	    components:{
	     	'base-filter-bar': BaseFilterBar,
	     	'base-pagination': BasePagination,
	     	'base-pagination-info': BasePaginationInfo,
	     	'base-select-visible': BaseSelectVisible,
	    },
	    data() {
	    	return {
	    		perPage: 10,
	    		moreParams: {},
				fields: [
					{
						name: 'name',
						title: 'Name',
						sortField: 'name',
					},
					{
						name: '__slot:channels',
						title: 'Channels',
						dataClass: 'table-column-no-padding',
						titleClass: 'w200'
					},
					{
						name: '__slot:productCount',
						title: 'Products',
						sortField: 'product_count',
						titleClass: 'w220',
					},
					{
						name: '__slot:actions',
						titleClass: 'actions-single-column',
					},
				],
				loading: true,
				amountsShown: [
					{ text: '10', value: 10 },
					{ text: '25', value: 25 },
					{ text: '50', value: 50 },
					{ text: '100', value: 100 }
				],
				grid: base_url + "/categories/grid",
				css: {
					table: {
						tableClass: 'table table-striped table-bordered table-middle',
						ascendingIcon: 'sort-icon-asc',
						descendingIcon: 'sort-icon-desc',
						infoClass: '',
					},
				},
			}
	    },
	    mounted() {
	    	this.$events.$on('per-page', eventData => this.doVisibleSet(eventData))
           	this.$events.$on('filter-set', eventData => this.onFilterSet(eventData))
           	this.$events.$on('filter-reset', e => this.onFilterReset())
	    },
	    watch: {
			'perPage' (val, oldVal) {
		      this.$nextTick(function() {
		        	this.$refs.vuetable.refresh()
		      })
		    },
	    },
	    methods: {
	        onPaginationData (paginationData) {
	          	this.$refs.pagination.setPaginationData(paginationData)
	          	this.$refs.paginationInfo.setPaginationData(paginationData)
	        },
	        expandChannelsList () {
	        	$(event.target).next().toggleClass('open')
	        	$(event.target).toggleClass('open')
	        },
	        onChangePage (page) {
	          	this.$refs.vuetable.changePage(page)
	        },
	        editRow(rowData){
	        	console.log(rowData);
	        },
	        doVisibleSet (perPageValue) {
                this.perPage = perPageValue;
                Vue.nextTick( () => this.$refs.vuetable.refresh())
            },
	        onFilterSet (filterText) {
                this.moreParams = {
                    'filter': filterText
                }
                Vue.nextTick( () => this.$refs.vuetable.refresh())
            },
            onFilterReset () {
                this.moreParams = {}
                Vue.nextTick( () => this.$refs.vuetable.refresh())
            },
            onLoaded: function () {
                this.loading = false;
            }
		}
	};
</script>